import {freeBetsStore, freeSpinStore, spinStore, store} from "../store";
import {pixiComponents} from "../index";
import {t, TKeys} from "../translationService";
import {hideWinAmountInfoText, updateSpinBtnState} from "../controlPanel";
import {updateFreeBetBoard} from "../freeSpin";

class FreeBetGame {
    isFreeBetGameStarted = false;

    constructor() {
    }

    setIsFreeBetGameStarted(bool) {
        this.isFreeBetGameStarted = bool;
    }

    // Free bets are frozen while a free spin (bonus) round runs: those spins are
    // funded by the free spin itself, so they must not consume a free bet.
    isFreeBetSpin() {
        return this.isFreeBetGameStarted
            && !!freeBetsStore.freeBet
            && !freeSpinStore.isBonusGameStarted
            && !freeSpinStore.freeSpin;
    }

    freezeForBonusGame() {
        if (!this.isFreeBetGameStarted) {
            return;
        }
        this.setFreeSpinLeftTextVisibility(false);
    }

    resumeAfterBonusGame() {
        if (!this.isFreeBetGameStarted || !freeBetsStore.freeBet) {
            return;
        }
        spinStore.setSpinAmount(freeBetsStore.freeBet.amount);
        this.updateFreeSpinLeftText();
        // the win amount text shares this slot: it hands the slot back on the next spin
        if (!pixiComponents.cpItems.winAmountText.container.visible) {
            this.setFreeSpinLeftTextVisibility(true);
        }
        updateSpinBtnState({});
        updateFreeBetBoard();
    }

    startGame(data) {
        if (store.isDemo()) {
            return;
        }
        setTimeout(() => {
            this.setIsFreeBetGameStarted(true);
            freeBetsStore.setFreeBets(data);
            // if (freeBetsStore.getFreeBetLeftCount() === freeBetsStore.freeBet.quantity){
            //     window.parent.postMessage({
            //         event: 'free-bet-award',
            //         data: data,
            //     }, '*');
            // }

            data.quantity = data.quantity - data.usedQuantity;
            window.parent.postMessage({
                event: 'free-bet-award',
                data: data,
            }, '*');

            spinStore.setSpinAmount(data.amount);
            this.setFreeSpinLeftText(freeBetsStore.getFreeBetLeftCount());
            this.setFreeSpinLeftTextVisibility(true);
            hideWinAmountInfoText();
            updateSpinBtnState({});
            updateFreeBetBoard();
        }, 1000);
    }

    endGame(data) {
        this.setIsFreeBetGameStarted(false);
        this.setFreeSpinLeftTextVisibility(false);
        updateSpinBtnState({});
        setTimeout(() => {
            window.parent.postMessage({
                event: 'free-bet-end',
                data,
            }, '*');
        }, 2000);
        freeBetsStore.setFreeBets(null);
        updateFreeBetBoard();
    }

    setFreeSpinLeftText(leftCount) {
        const container = pixiComponents.cpItems.freeSpinLeftText.container;
        const amountText = pixiComponents.cpItems.freeSpinLeftText.amount;
        const titleText = pixiComponents.cpItems.freeSpinLeftText.title;

        if (leftCount === 0) {
            titleText.text = t(TKeys.LAST_FREE_BET);
            amountText.text = '';
        } else if (leftCount > 0) {
            titleText.text = t(TKeys.FREE_BETS_LEFT);
            amountText.text = leftCount;
            amountText.updatePos();
        }

        container.pivot.set(container.width / 2, container.height / 2);
        container.x = pixiComponents.app.screen.width / 2;
    }

    setFreeSpinLeftTextVisibility(bool) {
        const container = pixiComponents.cpItems.freeSpinLeftText.container;
        container.visible = bool;
    }

    updateFreeBet(data) {
        freeBetsStore.setFreeBets(data);
        this.updateFreeSpinLeftText();
    }

    updateFreeSpinLeftText() {
        this.setFreeSpinLeftText(freeBetsStore.getFreeBetLeftCount());
    }
}

export const freeBetGame = new FreeBetGame();